import Vue from 'vue';
import Vuex from 'vuex';

import clickup from './clickup';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    clickup,
  },
});
